import React, { Component } from 'react';
import { renderToString } from 'react-dom/server';
import * as Common from './../helpers/Common';
import * as User from './../helpers/User';
import * as Config from '../config/Config';

import Myquiz from './Myquiz';
import Flowplayer from '../components/Flowplayer';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {getNewPost} from '../actions/newPostAction';
const $= window.$;

class Cwsubdetails extends Component {
	constructor(props) {
		super(props);
        this.state={

			formattedContent:"",
            content_sub : '',
            templatebg : 'Template1',
            subject : '',
            subjects : [],
            chapters : [],
            chapter_name:'',
            chapter_id_pk : '',
            bookmark_img :'star-box-ovr',
            bookmark_title:'',
            txtSearch:'',
			dis_quiz : 'inline-block',
			dis_chap : 'none',
			subject_id : '',
			dis_cont : 'block',
			dis_ques : 'none',
			assessment_id : '',
			ids_media :[],


        };

       this.getChaptersid = this.getChaptersid.bind(this);

	    this.getChaptersCon = this.getChaptersCon.bind(this);

	    this.setBookmark = this.setBookmark.bind(this);

	    this.handleChange = this.handleChange.bind(this);

	    // this.markText = this.markText.bind(this);

	}

	_handleKeyPress(e) {
		if (e.key === "Enter") {
			this.handler('search',this.state.txtSearch);
		}
	}

	 markText(content_text) {

        let con_ket = content_text;
		let control_style={ position:'relative' };

		let content=[];

		con_ket=con_ket.split("##");

		// const { data } = this.props;

		// let trackData={

		// 	compseq_id: data.compseq_id,
		// 	lroom_id: data.learning_room_id,
		// 	divider_id: data.divider_id,
		// 	learner_id: data.learner_id,
		// 	dlr_id: data.dlr_id,
		// 	compo_type:data.compo_type
		// };

		let trackData={

            compseq_id: '',
            lroom_id: '',
            divider_id:'',
            learner_id:User.UserId(),        
            dlr_id:'',
			compo_type:'courseware'
		};

									//console.log(con_ket);

									if(con_ket.length>0){

											con_ket.map((val,i)=>{

														if(val.match(/audio_player/g)){
															let audio_file_name=val.split("audio_player_");

															let audioplayer=<span key={`audio_player_${i}`}><audio controls style={control_style} >
										     			<source src={`${Config.rootDomainUrl+audio_file_name[1]}`} type="audio/mpeg" width="400" height="50"/>
										    		</audio></span>

																content.push(audioplayer);
														}else if(val.match(/video_player/g)){

															let video_file_name=val.split("video_player_");
															//let video_file_type = video_file_name[1].substr(-3);
															let video_file_type = video_file_name[1].split('.').pop();
															//alert(video_file_type);														

															let video_playlist={
																share:false,
																ratio: 9/16,
																clip:{
																  sources: [
																		{
																		   
																			type: "video/"+video_file_type,
																			src:Config.rootDomainUrl+video_file_name[1]
																		}
																	]
																}
															  };
															

																content.push(<span key={`video_player_${i}`}><Flowplayer  playlist={video_playlist} trackData={trackData} /></span>);

														}else if(val.match(/image_viewer/g)){
															// alert(val);
															let image_file_name=val.split("image_viewer_");

															content.push(<img key={`image_viewer_${i}`} alt="image" src={Config.rootDomainUrl+image_file_name[1]} style={{width:'680px'}} />);

														}else{

																content.push(<span key={`content_${i}`} dangerouslySetInnerHTML={{__html: val}}/>);
														}


											});
									}

        return content;

    }



	componentWillReceiveProps(nextProps) {

        if(nextProps.subject_id!=undefined){
         	let id = nextProps.subject_id;
         	this.getSubject(id);
        }

        if(nextProps.materials != undefined){
        	this.setState({
        		subjects : nextProps.materials,
        		chapters : [],
        	})
        }



    }

    setBookmark(chap_id){
    	// alert(chap_id);
    	var chap_id = chap_id;
    	let learnerID = Common.getUserData("id", true);
    	 Common.reactLoader("show", "Please wait...");
	    	fetch(Config.domainUrl+'resources/bookmark', {
	                method: 'POST',
	                headers: {
	                  'Accept': 'application/json',
	                  'Content-Type': 'application/json',
					  'Authorization':'Bearer ' +Common.getTokenData()
	                },
	                  body: JSON.stringify({
	                    chap_id:chap_id,learnerID:learnerID
	                  })
	                }).then((response) => response.json())
	               .then((responseJson) => {
	               	Common.reactLoader("hide");
	                 if (responseJson.status == 0) {
				       Common.message(responseJson.message,responseJson.errors,'error');
				    }else{
				      Common.message('Success',responseJson.message,'success');
				      this.setState({
				      	bookmark_img : responseJson.bookmark_img,
            			bookmark_title: responseJson.bookmark_title,
				      })
				    }


	   		 });

    }

    handleChange(e){
    	this.setState({
    		[e.target.name] : e.target.value
    	})
    }


   getChaptersCon(chap_id,sub_id){

   		var chapter_id = chap_id;
   		let learnerID = Common.getUserData("id", true);
   		 Common.reactLoader("show", "Please wait...");
	    	fetch(Config.domainUrl+'resources/chapters-content', {
	                method: 'POST',
	                headers: {
	                  'Accept': 'application/json',
	                  'Content-Type': 'application/json',
					  'Authorization':'Bearer ' +Common.getTokenData()
	                },

	                  body: JSON.stringify({
	                    chapter_id:chapter_id,learnerID:learnerID,sub_id:sub_id
	                  })
	                }).then((response) => response.json())
	               .then((responseJson) => {
	               	//alert(responseJson);
	               	Common.reactLoader("hide");
	               	if(responseJson.status != 0){

		                this.setState({
							formattedContent:this.markText(responseJson.content),
		                    content_sub : responseJson.content,
		                  	chapter_name : responseJson.chapter_name,
		                  	chapter_id_pk : chapter_id,
		                  	bookmark_img : responseJson.bookmark.img,
	            			bookmark_title:responseJson.bookmark.title,
	            			assessment_id : responseJson.bookmark.ass_id,

		                });

		                setTimeout(() => {
							this.props.getNewPost();
				          }, 5000);        
	               	}


	   		 });



   }


    getChaptersid(){
    	if($('#chapter_menu').css('display') == 'none'){
    		$("#chapter_menu").css('display','block');
    	}
    	else{
    		$("#chapter_menu").css('display','none');
    	}

    }

    getSubject(id=""){


    	var sub_i = $("select#cmbSubject").val();
    	let learnerID = Common.getUserData("id", true);
    	if(sub_i !="" && id==""){
    		var subject = sub_i;
    	}else{
    		var subject = id;
    	}


					// alert(subject);
					// console.log(sub_i);
					if(subject!=''){

							let sub_id = subject.split('_');
							let subject_id = sub_id[0];
							let tmp_id =  sub_id[1];
							let sub =  sub_id[2];
							Common.reactLoader("show", "Please wait...");
							fetch(Config.domainUrl+'resources/subject-content', {
								method: 'POST',
								headers: {
									'Accept': 'application/json',
									'Content-Type': 'application/json',
									'Authorization':'Bearer ' +Common.getTokenData()
								},

								body: JSON.stringify({
									subject_id:subject_id,tmp_id:tmp_id,subject:sub,learnerID:learnerID
								})
							}).then((response) => response.json())
							.then((responseJson) => {
								Common.reactLoader("hide");
								//alert(JSON.stringify(responseJson));



								this.setState({
									formattedContent:this.markText(responseJson.content),
									subject_id:subject_id,
									content_sub:responseJson.content,
									templatebg:responseJson.templatebg,
									subject:responseJson.subject,
									chapters : responseJson.chapters,
									chapter_name : responseJson.chapter_name,
									chapter_id_pk : responseJson.chapter_id_pk,
									bookmark_img : responseJson.bookmark.img,
									bookmark_title:responseJson.bookmark.title,
									assessment_id : responseJson.bookmark.ass_id
									
								});

								setTimeout(() => {
									this.props.getNewPost();
						          }, 5000);        


							});
					}

					Common.downTabClose();
					Common.winResize();


    }

    componentDidMount() {
    	const {subject_id} = this.props;
    	const {materials} = this.props;
    	this.setState({
        		subjects : materials,
        		chapters : [],
        });

        if(subject_id != "" || subject_id != undefined){

        	this.getSubject(subject_id);
        }
    	const {chap_sub} = this.props;
    	if(chap_sub != "" && subject_id == undefined){
    		let chasub = chap_sub;
    		if(chasub != undefined){
    			let chsub = chasub.split('__');
    			let sub = chsub[0];
    			let chap = chsub[1];
    			if(sub != "" ){
    				this.getSubject(sub);
    			}

	    		setTimeout(()=>{
	    			if(chap){
	    				this.getChaptersCon(chap,sub);
	    			}
	  			 },1500);
    		}


    	}



    }

    changeType(type){

    	if(type == 'quiz'){
    		if(this.state.dis_quiz == "inline-block"){
    			this.setState({
    				dis_quiz : 'none',
    				dis_chap : 'inline-block',
    				dis_ques : 'block',
    				dis_cont : 'none',
    			})

    		}
	    	else{
	    		this.setState({
	    			dis_quiz : 'inline-block',
	    			dis_chap : 'none',
	    			dis_ques : 'none',
    				dis_cont : 'block',
	    		})
	    	}
    	}
    }

    handler(type,data_sent){


	    this.props.handler(type,data_sent);

	}




		render() {

			let chap_con = this.state.chapters.map((chap,i)=>{
				return(
						<div key={`chapters_${chap.chapter_id_pk}_${i}`} className="chap_title2" onClick={(e)=>this.getChaptersCon(chap.chapter_id_pk,chap.subject_ids,e)}  id={chap.chapter_id_pk}>{chap.chapter_name}</div>
					)
			});



			let subject_select = this.state.subjects.map((subject,i)=>{

				return(
						<option key={`subjects_${subject.subject_id_pk}_${i}`} value={subject.subject_id_pk+'_'+subject.template_id_fk+'_'+subject.subject}>{subject.subject}</option>
					)
			});




			return (

					<div className="main-inner">
						<div className="yellow-course">

							<div className="search-right">
									<input id="txtSearch" name="txtSearch" type="text" onChange={(e)=>this.handleChange(e)} onKeyPress={(e)=>this._handleKeyPress(e)}/>
									<input value="Search" border="0" type="button" id="sebut" onClick={e=>this.handler('search',this.state.txtSearch)}/>
									<span id="bookmark_div">
										<a href="javascript:void(0);" onClick={(e)=>this.setBookmark(this.state.chapter_id_pk)} title={this.state.bookmark_title}>
											<img src={process.env.PUBLIC_URL+"/images/"+this.state.bookmark_img+".jpg"} align="texttop"  border="0" />
										</a>
									</span>
							</div>
							<a href="javascript:void(0)" style={{display:this.state.dis_chap}} title="View Chapters" id="view-chap" className="self-chk" onClick={e=>this.changeType('quiz')}>View Chapters</a>
							<a href="javascript:void(0)" style={{display:this.state.dis_quiz}} title="Self-check Quiz" id="self-chk" className="self-chk" onClick={e=>this.changeType('quiz')}>Self-check Quiz</a>
							<a href="javascript:void(0)" title="My Bookmarks" className="my-book" onClick={e=>this.handler('bookmark')}>My Bookmarks</a>
						</div>
						<div className="border-box">
							<div className="title-box-gray title-box-blue">
								<div className="right">
									<form name="SubjectFrm" id="SubjectFrm" >
										<select className="sub_cmbbox" id="cmbSubject" onChange={(e)=>this.getSubject()} style={{width:'210px'}} name="cmbSubject">
											<option value="">Choose another subject</option>
											{subject_select}
										</select>
									</form>
								</div>
							{this.state.subject}</div>
	                    	<section id="semana-scroll-inner" className="scroll">
		                        <section className="viewport">
		                            <section className="overview">
		                                <div className="inner-content">
											<div style={{}}>
												<div id="chapter_menu" className="chap_main menu"  style={{display:'none'}}>
													{chap_con}
												</div>
												<div className="chap_main" id="chapter_latest" top="0">

								                	<div className="slt_chp" align="right">
								                		<span><a href="javascript:void(0);" onClick={(e)=>this.getChaptersid(e)}><img src={process.env.PUBLIC_URL+"/images/change_chapter.jpg"} width="185" height="38" border="0"  /></a></span>
								                	</div>
													<h3>{this.state.chapter_name}</h3>

								                    <div className={"courseware_contentbg"+this.state.templatebg} style={{display:this.state.dis_cont}}>
													    <div className="top_img">
													    	<img src={process.env.PUBLIC_URL+"/images/courseware_templates/"+this.state.templatebg+"/top-img.png"} alt="" title="" />
													    </div>
															<p>
														 {this.state.formattedContent}
															</p>
														<div className={"courseware_footer"+this.state.templatebg}>
														</div>
													</div>
													<div style={{display:this.state.dis_ques}} className="courseware_template">
          											 <Myquiz chaptersub={this.state.assessment_id+'_'+this.state.subject_id+'_'+this.state.chapter_id_pk} handler={this.setComponentPanel}/>
													</div>
								            	</div>
								          	</div>
		          						</div>
		          					</section>
		        				</section>
	    					</section>
						</div>
					</div>

			);
		}
}

function mapDispatchToProps(dispatch) {
      
  return  bindActionCreators({getNewPost}, dispatch);
 
}

export default connect(null,mapDispatchToProps)(Cwsubdetails);


// WEBPACK FOOTER //
// ./src/learning_resources/Cwsubdetails.js